// extracted by mini-css-extract-plugin
export default {"counter":"counter_counter__Ufr8v","mobile":"counter_mobile__1iXHt"};